(function () {
    angular.module('emarket.main.profile').controller('ProfileCardController', ['$mdDialog', 'user', function ($mdDialog, user) {
        var vm = this;
        vm.profile = user;
        vm.close = function () {
            $mdDialog.hide();
        };
    }]);
}());
